import ingredientsRoutes from "../inventory/modules/ingredients/routes";
import ingredientCategoriesRoutes from "./modules/ingredientCategories/routes";
import inventoryTurnoversRoutes from "./modules/inventoryTurnovers/routes";
import warehouseRoutes from "./modules/warehouse/routes";
import dailyStockOutcomesRoutes from "./modules/dailyStockOutcomes/routes";

export default [
  ...ingredientsRoutes,
  ...ingredientCategoriesRoutes,
  ...inventoryTurnoversRoutes,
  ...warehouseRoutes,
  ...dailyStockOutcomesRoutes,
];
